import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Select, Skeleton } from '@mantine/core';
import { HiChevronDown } from 'react-icons/hi2';
import { FormattedMessage } from 'react-intl';
import Chart from '../shared/Chart';
import { getData } from '../../services/fetch-service';

const statusList = [
    { value: 1, label: 'Aktive' },
    { value: 2, label: 'Shuar' },
    { value: 3, label: 'Pasive' },
];

function Charts(props) {
    const { locale } = props;
    const currentYear = new Date().getFullYear();

    const [Types, setTypes] = useState([]);
    const [Komunat, setKomunat] = useState([]);
    const [bussinessType, setStatBussinessType] = useState([]);
    const [bussinessSector, setStatBussinessSector] = useState([]);
    const [typeSelected, setTypeSelected] = useState(0);
    const [Years, setYears] = useState([]);
    const [yearSectionSelected, setYearSectionSelected] = useState(currentYear);
    const [yearTypeSelected, setYearTypeSelected] = useState(currentYear);
    const [KomunaSectorSelected, setKomunaSectorSelected] = useState(0);
    const [KomunaBussinessTypeSelected, setKomunaBussinessTypeSelected] = useState(0);
    const [statusForType, setStatusForType] = useState(0);
    const [statusForSector, setStatusForSector] = useState(0);
    const [sectorLoader, setSectorLoader] = useState(true);
    const [bussinessTypeLoader, setBussinesTypeLoader] = useState(true);

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const recentYears = [];

        for (let i = 0; i < 24; i++) {
            recentYears.push({ Year: currentYear - i });
        }
        setYears(recentYears);
    }, []);

    const [latestBussinessTypeRequest, setLatestBussinessTypeRequest] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        setLatestBussinessTypeRequest(abortController);
        getData(`Services/StatLlojiBiznesve?Viti=${yearTypeSelected}&KomunaId=${KomunaBussinessTypeSelected}&status=${statusForType}&Gjuha=${locale}`)
            .then((response) => {
                if (!abortController.signal.aborted) {
                    setStatBussinessType(response.data);
                    setBussinesTypeLoader(false);
                }
            });
        return () => {
            abortController.abort();
        };
    }, [locale, yearTypeSelected, statusForType, KomunaBussinessTypeSelected]);

    useEffect(() => {
        if (latestBussinessTypeRequest) {
            latestBussinessTypeRequest.abort();
        }
    }, [locale, yearTypeSelected, statusForType, KomunaBussinessTypeSelected]);

    useEffect(() => {
        getData(`Services/LlojetEBiznesit?Gjuha=${locale}`).then((response) => {
            setTypes(response.data);
        });
        getData(`Services/ListaKomunave?Gjuha=${locale}`).then((response) => {
            setKomunat(response.data);
        });
    }, [locale]);

    const [latestSectorRequest, setLatestSectorRequest] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        setLatestSectorRequest(abortController);
        getData(`Services/StatSektoriBiznesve?LlojiBiznesitID=${typeSelected}&Viti=${yearSectionSelected}&KomunaId=${KomunaSectorSelected}&status=${statusForSector}`, { signal: abortController.signal })
            .then((response) => {
                if (!abortController.signal.aborted) {
                    setStatBussinessSector(response.data);
                    setSectorLoader(false);
                }
            })
        return () => {
            abortController.abort();
        };
    }, [typeSelected, yearSectionSelected, statusForSector, KomunaSectorSelected]);

    useEffect(() => {
        if (latestSectorRequest) {
            latestSectorRequest.abort();
        }
    }, [typeSelected, yearSectionSelected, statusForSector, KomunaSectorSelected]);

    const BussinessTypes = Types.map((type) => ({
        key: type.recentYears,
        value: type.LlojiBiznesitID || '',
        label: type.Pershkrimi || '',
    }));

    const KomunatList = Komunat.map((type) => ({
        key: type.id,
        value: type.id || '',
        label: type.pershkrimi || '',
    }));

    const YearSelect = Years.map((y) => ({
        key: y.Year,
        value: y.Year || '',
        label: y.Year.toString() || '',
    }));

    const bussinessTypeLabel = bussinessType.map((item) => item.NR + ' - ' + item.Pershkrimi);
    const bussinessTypeData = bussinessType.map((item) => item.NR);

    const bussinessSectorLabel = bussinessSector.map((item) => item.NR + ' - ' + item.Pershkrimi);
    const bussinessSectorData = bussinessSector.map((item) => item.NR);

    let placeholderTextMunicipality;
    let placeholderTextStatus;
    let placeholderTextYear;
    let placeholderTextBusinessType;
    if (locale === 'sq') {
        placeholderTextYear = 'Viti';
        placeholderTextMunicipality = 'Komuna';
        placeholderTextStatus = 'Statusi';
        placeholderTextBusinessType = 'Lloji biznesit';
    } else if (locale === 'en') {
        placeholderTextYear = 'Year'
        placeholderTextMunicipality = 'Municipality';
        placeholderTextStatus = 'Status';
        placeholderTextBusinessType = 'Business type';
    } else if (locale === 'sr') {
        placeholderTextYear = 'Godine';
        placeholderTextMunicipality = 'Opština';
        placeholderTextStatus = 'Status';
        placeholderTextBusinessType = 'Poslovni tip'
    }

    return (
        <div className="charts">
            <div className="charts-header">
                <h1 className="charts-title"><FormattedMessage id="BusinessStatistics" defaultMessage="STATISTIKAT E BIZNESEVE" /></h1>
                <h4 className="charts-subtitle"><FormattedMessage id="DescriptionStatistics" defaultMessage="Në vijim mund ti shikoni statistikat e bizneseve për vite" /></h4>
            </div>
            <div className="charts-section">
                <div className="chartbox">
                    <h3 className="chartbox-title"><FormattedMessage id="NrBusinessesType" defaultMessage="Numri i bizneseve sipas llojit" /></h3>
                    <div className="select-inputs inputs-btype">
                        <Select
                            placeholder={placeholderTextYear}
                            searchable
                            clearable
                            allowDeselect
                            rightSection={
                                yearTypeSelected ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setYearTypeSelected(0);
                                } else {
                                    setYearTypeSelected(selectedValue);
                                }
                            }}
                            value={yearTypeSelected}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={YearSelect}
                        />
                        <Select
                            placeholder={placeholderTextStatus}
                            searchable
                            clearable
                            allowDeselect
                            rightSection={
                                statusForType ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setStatusForType(0);
                                } else {
                                    setStatusForType(selectedValue);
                                }
                            }}
                            value={statusForType}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={statusList}
                        />
                        <Select
                            placeholder={placeholderTextMunicipality}
                            searchable
                            clearable
                            allowDeselect
                            rightSection={
                                KomunaBussinessTypeSelected ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setKomunaBussinessTypeSelected(0);
                                } else {
                                    setKomunaBussinessTypeSelected(selectedValue);
                                }
                            }}
                            value={KomunaBussinessTypeSelected}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={KomunatList}
                        />
                    </div>
                    <div className="chart-arbk">
                        {!bussinessTypeLoader ? (
                            <Chart
                                series={bussinessTypeData}
                                customOptions={{ labels: bussinessTypeLabel }}
                                legend="left"
                                height="100%"
                                type="pie"
                            />
                        ) : (
                            <div className="sect-skeleton">
                                <Skeleton className="skeleton-pie" height={380} circle mb="xl" />
                                <div className="skeleton-text">
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="chartbox charbox-sectors">
                    <h3 className="chartbox-title"><FormattedMessage id="NrBusinessesSector" defaultMessage="Numri i bizneseve sipas sektorëve" /></h3>
                    <div className="select-inputs">
                        <Select
                            placeholder={placeholderTextYear}
                            searchable
                            clearable
                            allowDeselect
                            // disabled={sectorLoader}
                            rightSection={
                                yearSectionSelected ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setYearSectionSelected(0);
                                    setSectorLoader(true);
                                } else {
                                    setYearSectionSelected(selectedValue);
                                }
                            }}
                            value={yearSectionSelected}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={YearSelect}
                        />
                        <Select
                            placeholder={placeholderTextBusinessType}
                            searchable
                            clearable
                            className="typeFilter"
                            allowDeselect
                            rightSection={
                                typeSelected ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setTypeSelected(0);
                                    setSectorLoader(true);
                                } else {
                                    setTypeSelected(selectedValue);
                                }
                            }}
                            value={typeSelected}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={BussinessTypes}
                        />
                        <Select
                            placeholder={placeholderTextStatus}
                            searchable
                            clearable
                            allowDeselect
                            rightSection={
                                statusForSector ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setStatusForSector(0);
                                    setSectorLoader(true);
                                } else {
                                    setStatusForSector(selectedValue);
                                }
                            }}
                            value={statusForSector}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={statusList}
                        />
                        <Select
                            placeholder={placeholderTextMunicipality}
                            searchable
                            clearable
                            allowDeselect
                            rightSection={
                                KomunaSectorSelected ? (
                                    ''
                                ) : (
                                    <HiChevronDown size="1rem" />
                                )
                            }
                            rightSectionWidth={30}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) {
                                    setKomunaSectorSelected(0);
                                    setSectorLoader(true);
                                } else {
                                    setKomunaSectorSelected(selectedValue);
                                }
                            }}
                            value={KomunaSectorSelected}
                            styles={{ rightSection: { pointerEvents: 'none' } }}
                            data={KomunatList}
                        />
                    </div>
                    <div className="chart-arbk">
                        {!sectorLoader ? (
                            <Chart
                                series={bussinessSectorData}
                                customOptions={{ labels: bussinessSectorLabel }}
                                legend="left"
                                height="100%"
                                type="donut"
                            />
                        ) : (
                            <div className="sect-skeleton">
                                <Skeleton className="skeleton-pie" height={380} circle mb="xl" />
                                <div className="skeleton-text">
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                    <Skeleton height={14} radius="xl" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(Charts);
